import { useEffect, useState } from 'react';
import { ref, onValue } from 'firebase/database';
import { db, auth } from '../../integrations/firebase';

/**
 * The signed-in agent's live call, realtime: tc/live/{uid} (Caller 4.30+; the
 * proxy writes it, the agent may read only their own). `enabled` = false keeps
 * the listener off entirely (no linked phone). A permission error — the rules
 * not deployed yet — is treated as "no live call", silently.
 */
export function useLiveCall(enabled = true) {
    const [live, setLive] = useState(null);
    const uid = auth.currentUser?.uid || '';
    useEffect(() => {
        if (!enabled || !uid) { setLive(null); return undefined; }
        const unsub = onValue(ref(db, `tc/live/${uid}`), s => setLive(s.val() || null), () => setLive(null));
        return () => unsub();
    }, [enabled, uid]);
    return live;
}

export default useLiveCall;
